/* Progressive enhancements: content and native specification disclosures work without JS. */
(() => {
  if (window.agProductStory) { window.agProductStory.refresh(); return; }
  const instances = new Map();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function enhance(story) {
    const undo = [];
    const listen = (node, event, handler, options) => {
      node.addEventListener(event, handler, options);
      undo.push(() => node.removeEventListener(event, handler, options));
    };
    const button = (label, className, text = label) => {
      const node = document.createElement('button');
      node.type = 'button'; node.className = className; node.textContent = text;
      node.setAttribute('aria-label', label); return node;
    };
    const lineIcon = path => {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '24'); svg.setAttribute('height', '24');
      svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.6'); svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round'); svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      const shape = document.createElementNS(svg.namespaceURI, 'path');
      shape.setAttribute('d', path); svg.append(shape); return svg;
    };
    // Preserve the existing lead form and its click handler. Only replace its
    // envelope artwork, including when the app mounts after the product story.
    const controlStyle = document.createElement('style');
    controlStyle.textContent = `
      .globo-form-id-123680 .floating-button .ag-inquiry-icon{display:block!important;width:26px!important;height:26px!important;margin:0!important;pointer-events:none}
      .globo-form-id-123680 .floating-button .ag-inquiry-icon path{fill:none!important;stroke:currentColor!important;stroke-width:1.6!important}
      .ag-story .ag-image-hint svg{display:block;width:18px;height:18px;pointer-events:none}
    `;
    document.head.append(controlStyle);
    const changedForms = new Map();
    const updateFormIcon = () => {
      document.querySelectorAll('.globo-form-id-123680 .floating-button .fabLabel svg[data-icon="envelope"]').forEach(oldIcon => {
        const trigger = oldIcon.closest('.floating-button');
        const icon = lineIcon('M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7 M8 8h4 M8 12h2 M8 16h3 M14 13l1-4 5-5 3 3-5 5-4 1Z M18.5 5.5l3 3');
        icon.classList.add('ag-inquiry-icon'); oldIcon.replaceWith(icon);
        if (!changedForms.has(trigger)) {
          const attrs = ['title','aria-label','role','tabindex','aria-haspopup'];
          changedForms.set(trigger, {attrs:attrs.map(name => [name, trigger.getAttribute(name)]), icons:[]});
          trigger.setAttribute('title', 'Sales inquiry'); trigger.setAttribute('aria-label', 'Open sales inquiry form');
          trigger.setAttribute('role', 'button'); trigger.setAttribute('tabindex', '0'); trigger.setAttribute('aria-haspopup', 'dialog');
          listen(trigger, 'keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); trigger.click(); }
          });
        }
        changedForms.get(trigger).icons.push([icon, oldIcon]);
      });
    };
    updateFormIcon();
    const formObserver = new MutationObserver(updateFormIcon);
    formObserver.observe(document.body, {childList:true, subtree:true});
    undo.push(() => {
      formObserver.disconnect(); controlStyle.remove();
      changedForms.forEach(({attrs, icons}, trigger) => {
        icons.forEach(([icon, oldIcon]) => { if (icon.isConnected) icon.replaceWith(oldIcon); });
        attrs.forEach(([name, value]) => { if (value === null) trigger.removeAttribute(name); else trigger.setAttribute(name, value); });
      });
    });
    const nav = story.querySelector('.ag-subnav');
    let updateNavigation = () => {};
    if (nav) {
      const shell = nav.parentElement;
      shell.classList.add('ag-nav-shell');
      const progress = document.createElement('div');
      progress.className = 'ag-reading-progress'; progress.setAttribute('aria-hidden', 'true');
      shell.append(progress);
      const links = [...nav.querySelectorAll('a[href^="#"]')];
      const resolveTarget = hash => {
        let id;
        try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
        const target = document.getElementById(id);
        return target && story.contains(target) ? target : null;
      };
      const targets = links.map(link => resolveTarget(link.hash));
      // The shared storefront header is sticky at the section wrapper, several
      // ancestors above its <header>. Measure that wrapper's visible lower edge.
      const headers = [...document.querySelectorAll('.ag-global-header-section, .shopify-section--header, header')].filter(h => !story.contains(h));
      let frame = 0, animation = 0, settleTimer = 0, intent = null;
      const headerOffset = () => {
        let offset = 0;
        for (const header of headers) {
          const rect = header.getBoundingClientRect();
          const anchored = [header, header.parentElement].some(h => h && ['fixed', 'sticky'].includes(getComputedStyle(h).position));
          if (anchored && rect.top <= 2 && rect.bottom > 0 && rect.height < 240) offset = Math.max(offset, Math.ceil(rect.bottom));
        }
        return offset;
      };
      const destination = target => Math.max(0, Math.min(
        document.documentElement.scrollHeight - innerHeight,
        scrollY + target.getBoundingClientRect().top - headerOffset() - shell.offsetHeight - 20
      ));
      const stopNavigation = () => {
        cancelAnimationFrame(animation); animation = 0;
        clearTimeout(settleTimer); intent = null;
      };
      updateNavigation = () => {
        const offset = headerOffset();
        story.style.setProperty('--ag-nav-top', offset + 'px');
        // Native fragment scrolling adds the document's scroll-padding to the
        // target's scroll-margin. Account for that once, including no-JS links.
        const rootPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
        story.style.setProperty('--ag-anchor-offset', Math.max(0, offset + shell.offsetHeight + 20 - rootPadding) + 'px');
        const threshold = offset + shell.offsetHeight + 65;
        let index = -1;
        targets.forEach((target, i) => { if (target && target.getBoundingClientRect().top <= threshold) index = i; });
        if (intent) index = targets.indexOf(intent);
        links.forEach((link, i) => {
          if (i === index) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const rect = story.getBoundingClientRect();
        const distance = Math.max(1, story.offsetHeight - innerHeight);
        progress.style.setProperty('--ag-progress', Math.max(0, Math.min(1, -rect.top / distance)));
      };
      const schedule = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = 0; updateNavigation();
          // Re-align only a recent, explicit navigation when late images or the
          // sticky header change geometry. Any manual input cancels this intent.
          if (intent && !animation && intent.isConnected) {
            const top = destination(intent);
            if (Math.abs(top - scrollY) > 1) window.scrollTo({top, behavior:'instant'});
          }
        });
      };
      const navigate = (target, focus = false) => {
        stopNavigation(); intent = target;
        const start = scrollY, started = performance.now();
        const duration = reducedMotion() ? 0 : 500;
        const tick = now => {
          const fraction = duration ? Math.min(1, (now - started) / duration) : 1;
          const ease = 1 - Math.pow(1 - fraction, 3);
          updateNavigation();
          window.scrollTo({top:start + (destination(target) - start) * ease, behavior:'instant'});
          if (fraction < 1) { animation = requestAnimationFrame(tick); return; }
          animation = 0;
          if (focus) {
            const hadTabindex = target.hasAttribute('tabindex');
            if (!hadTabindex) target.setAttribute('tabindex', '-1');
            target.focus({preventScroll:true});
            if (!hadTabindex) target.removeAttribute('tabindex');
          }
          settleTimer = setTimeout(() => { intent = null; schedule(); }, 4000);
          schedule();
        };
        animation = requestAnimationFrame(tick);
      };
      listen(story, 'click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const target = resolveTarget(link.hash);
        if (!target) return;
        // Handle before the theme's delegated scrollIntoView handler; leave all
        // unrelated storefront links and modified clicks untouched.
        event.preventDefault();
        if (location.hash !== link.hash) history.pushState(null, '', link.hash);
        navigate(target, true);
      });
      const followHash = () => {
        const target = resolveTarget(location.hash);
        if (target) navigate(target); else stopNavigation();
      };
      listen(window, 'hashchange', followHash);
      listen(window, 'popstate', followHash);
      listen(window, 'wheel', stopNavigation, {passive:true});
      listen(window, 'touchstart', stopNavigation, {passive:true});
      listen(window, 'pointerdown', stopNavigation, {passive:true});
      listen(window, 'keydown', event => {
        if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ','Tab','Escape'].includes(event.key)) stopNavigation();
      });
      listen(window, 'scroll', schedule, {passive:true});
      listen(window, 'resize', schedule, {passive:true});
      // iOS browser chrome and the software keyboard resize the visual viewport.
      if (window.visualViewport) listen(window.visualViewport, 'resize', schedule, {passive:true});
      listen(document, 'load', schedule, true);
      let observer;
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(schedule);
        [story, shell, document.querySelector('main'), ...headers].filter(Boolean).forEach(node => observer.observe(node));
      }
      const initialFrame = requestAnimationFrame(() => { updateNavigation(); if (location.hash) followHash(); });
      schedule();
      undo.push(() => {
        stopNavigation(); cancelAnimationFrame(frame); cancelAnimationFrame(initialFrame); observer?.disconnect();
        shell.classList.remove('ag-nav-shell'); progress.remove();
        story.style.removeProperty('--ag-nav-top'); story.style.removeProperty('--ag-anchor-offset');
        links.forEach(link => link.removeAttribute('aria-current'));
      });
    }

    // Native scrolling preserves touch gestures, selectable text and every original card.
    story.querySelectorAll('.ag-scene-grid, .ag-system-grid').forEach((grid, galleryIndex) => {
      const cards = [...grid.children];
      if (cards.length < 2) return;
      const systems = grid.classList.contains('ag-system-grid');
      const label = systems ? 'Hardware views' : 'Applications';
      const shell = document.createElement('div'); shell.className = 'ag-carousel';
      shell.setAttribute('role', 'region'); shell.setAttribute('aria-label', label);
      shell.setAttribute('aria-roledescription', 'carousel');
      grid.before(shell); shell.append(grid);
      const oldId = grid.getAttribute('id');
      grid.id = oldId || `ag-gallery-${story.id || 'product'}-${galleryIndex}`;
      grid.classList.add('ag-carousel-track'); grid.tabIndex = 0;
      grid.setAttribute('aria-label', `${label}: swipe or use the arrow keys to browse`);
      const labels = cards.map(card => card.querySelector('h3').textContent.trim());
      cards.forEach((card, i) => {
        card.setAttribute('role', 'group'); card.setAttribute('aria-roledescription', 'slide');
        card.setAttribute('aria-label', `${i + 1} of ${cards.length}: ${labels[i]}`);
        if (!systems) {
          const copy = document.createElement('div'); copy.className = 'ag-slide-copy';
          const figure = card.querySelector('figure');
          while (figure.nextSibling) copy.append(figure.nextSibling);
          card.append(copy);
          undo.push(() => { copy.replaceWith(...copy.childNodes); });
        }
      });
      const controls = document.createElement('div'); controls.className = 'ag-carousel-controls';
      const toggle = button(`View all ${label.toLowerCase()}`, 'ag-carousel-toggle', 'View all');
      toggle.setAttribute('aria-controls', grid.id); toggle.setAttribute('aria-expanded', 'false');
      const paging = document.createElement('div'); paging.className = 'ag-carousel-paging';
      const previous = button(`Previous ${systems ? 'hardware view' : 'application'}`, 'ag-carousel-arrow', '←');
      const next = button(`Next ${systems ? 'hardware view' : 'application'}`, 'ag-carousel-arrow', '→');
      const counter = document.createElement('span'); counter.className = 'ag-carousel-counter';
      const markers = document.createElement('div'); markers.className = 'ag-carousel-markers';
      markers.setAttribute('role', 'group'); markers.setAttribute('aria-label', `Choose ${label.toLowerCase()}`);
      const status = document.createElement('p'); status.className = 'ag-interaction-status';
      status.setAttribute('role', 'status');
      let current = 0, expanded = false, frame = 0, resizeFrame = 0;
      const update = (announce = false) => {
        counter.textContent = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
        previous.setAttribute('aria-disabled', String(current === 0));
        next.setAttribute('aria-disabled', String(current === cards.length - 1));
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        if (announce) status.textContent = `${current + 1} of ${cards.length}: ${labels[current]}`;
      };
      const go = (index, instant = false) => {
        if (expanded) return;
        current = Math.max(0, Math.min(cards.length - 1, index));
        const left = grid.scrollLeft + cards[current].getBoundingClientRect().left - grid.getBoundingClientRect().left;
        grid.scrollTo({left, behavior:instant || reducedMotion() ? 'instant' : 'smooth'});
        update(true);
      };
      const dots = cards.map((card, i) => {
        const dot = button(`Show ${labels[i]}`, 'ag-carousel-marker', '');
        dot.setAttribute('aria-controls', grid.id); listen(dot, 'click', () => go(i));
        markers.append(dot); return dot;
      });
      paging.append(previous, counter, next); controls.append(toggle, markers, paging); shell.append(controls, status);
      listen(previous, 'click', () => go(current - 1)); listen(next, 'click', () => go(current + 1));
      listen(grid, 'scroll', () => {
        if (frame || expanded) return;
        frame = requestAnimationFrame(() => {
          frame = 0;
          const left = grid.getBoundingClientRect().left;
          const distances = cards.map(card => Math.abs(card.getBoundingClientRect().left - left));
          const nearest = distances.indexOf(Math.min(...distances));
          if (current !== nearest) { current = nearest; update(true); }
        });
      }, {passive:true});
      listen(grid, 'keydown', event => {
        if (expanded || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        go(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : current + (event.key === 'ArrowLeft' ? -1 : 1));
        // When an image has focus, move focus with its slide instead of leaving it off screen.
        if (event.target !== grid) cards[current].querySelector('button')?.focus({preventScroll:true});
      });
      listen(grid, 'focusin', event => {
        const index = cards.findIndex(card => card.contains(event.target));
        if (index >= 0 && index !== current) go(index, true);
      });
      listen(toggle, 'click', () => {
        expanded = !expanded; shell.classList.toggle('ag-carousel--all', expanded);
        shell.setAttribute('aria-roledescription', expanded ? 'gallery' : 'carousel');
        grid.tabIndex = expanded ? -1 : 0;
        toggle.textContent = expanded ? 'Back to carousel' : 'View all';
        toggle.setAttribute('aria-label', expanded ? `Back to ${label.toLowerCase()} carousel` : `View all ${label.toLowerCase()}`);
        toggle.setAttribute('aria-expanded', String(expanded)); paging.hidden = expanded; markers.hidden = expanded;
        // Keep the mode switch in place when a tall gallery expands or collapses.
        shell.prepend(controls);
        if (!expanded) { shell.append(controls, status); go(current, true); }
        const rect = controls.getBoundingClientRect();
        if (rect.top < 100 || rect.bottom > innerHeight) controls.scrollIntoView({block:'center', behavior:'instant'});
        status.textContent = expanded ? `Showing all ${cards.length} ${label.toLowerCase()}` : `Showing ${labels[current]}`;
        updateNavigation();
      });
      let observer;
      if ('ResizeObserver' in window) {
        observer = new ResizeObserver(() => {
          cancelAnimationFrame(resizeFrame);
          resizeFrame = requestAnimationFrame(() => { if (!expanded) go(current, true); });
        });
        observer.observe(grid);
      }
      update();
      undo.push(() => {
        cancelAnimationFrame(frame); cancelAnimationFrame(resizeFrame); observer?.disconnect();
        grid.classList.remove('ag-carousel-track'); grid.removeAttribute('tabindex'); grid.removeAttribute('aria-label');
        if (oldId === null) grid.removeAttribute('id');
        cards.forEach(card => { card.removeAttribute('role'); card.removeAttribute('aria-roledescription'); card.removeAttribute('aria-label'); });
        shell.replaceWith(grid);
      });
    });

    // One accessible, keyboard-operated image viewer per product section.
    story.querySelectorAll('.ag-videos').forEach(module => {
      const choices = module.querySelector('.ag-video-choices');
      const panels = [...module.querySelectorAll('.ag-video-panel')];
      let active = 0;
      const stop = panel => {
        panel.querySelector('iframe')?.remove();
        panel.querySelector('.ag-video-play').hidden = false;
      };
      const select = index => {
        panels.forEach((panel, i) => {
          if (i !== index) stop(panel);
          panel.hidden = i !== index;
          choices.children[i].setAttribute('aria-pressed', String(i === index));
        });
        active = index;
      };
      panels.forEach((panel, i) => {
        const choice = button(panel.dataset.title, 'ag-video-choice');
        choice.setAttribute('aria-controls', panel.id);
        choices.append(choice);
        listen(choice, 'click', () => select(i));
        listen(choice, 'keydown', event => {
          let next = active;
          if (event.key === 'ArrowRight') next = (i + 1) % panels.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + panels.length) % panels.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = panels.length - 1;
          else return;
          event.preventDefault(); select(next); choices.children[next].focus();
        });
        const play = panel.querySelector('.ag-video-play');
        listen(play, 'click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube.com/embed/' + panel.dataset.videoId + '?playsinline=1&controls=1&rel=0&autoplay=1';
          frame.title = panel.dataset.title;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          play.hidden = true; panel.querySelector('.ag-video-stage').append(frame); frame.focus();
        });
      });
      choices.hidden = false; select(0);
      undo.push(() => { panels.forEach(panel => { stop(panel); panel.hidden = false; }); choices.replaceChildren(); choices.hidden = true; });
    });
    const images = [...story.querySelectorAll('img')].filter(img => !img.closest('.ag-videos, .ag-poster-art'));
    if (images.length && typeof HTMLDialogElement !== 'undefined') {
      const dialog = document.createElement('dialog'); dialog.className = 'ag-lightbox';
      dialog.setAttribute('aria-label', 'Product image viewer');
      const toolbar = document.createElement('div'); toolbar.className = 'ag-lightbox-toolbar';
      const counter = document.createElement('span'); counter.className = 'ag-lightbox-counter'; counter.setAttribute('aria-live', 'polite');
      const close = button('Close image viewer', 'ag-lightbox-close', '×');
      const zoom = button('Zoom in', 'ag-lightbox-zoom', '+');
      const actions = document.createElement('div'); actions.className = 'ag-lightbox-actions'; actions.append(zoom, close);
      toolbar.append(counter, actions);
      const stage = document.createElement('div'); stage.className = 'ag-lightbox-stage';
      const large = document.createElement('img'); large.draggable = false; stage.append(large);
      const footer = document.createElement('div'); footer.className = 'ag-lightbox-footer';
      const previous = button('Previous image', 'ag-lightbox-arrow', '←');
      const next = button('Next image', 'ag-lightbox-arrow', '→');
      const caption = document.createElement('p'); caption.className = 'ag-lightbox-caption';
      footer.append(previous, caption, next); dialog.append(toolbar, stage, footer); document.body.append(dialog);
      let current = 0, origin, previousOverflow = '', locked = false, zoomed = false;
      const setZoom = enabled => {
        zoomed = enabled && large.naturalWidth > 0;
        stage.classList.toggle('ag-is-zoomed', zoomed);
        zoom.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
        zoom.setAttribute('aria-pressed', String(zoomed)); zoom.textContent = zoomed ? '−' : '+';
        large.style.removeProperty('width'); large.style.removeProperty('height');
        if (zoomed) {
          const css = getComputedStyle(stage);
          const w = stage.clientWidth - parseFloat(css.paddingLeft) - parseFloat(css.paddingRight);
          const h = stage.clientHeight - parseFloat(css.paddingTop) - parseFloat(css.paddingBottom);
          const scale = Math.min(w / large.naturalWidth, h / large.naturalHeight) * 2;
          large.style.width = large.naturalWidth * scale + 'px'; large.style.height = large.naturalHeight * scale + 'px';
          stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
          stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
        } else { stage.scrollLeft = 0; stage.scrollTop = 0; }
      };
      const captions = images.map(img => img.closest('article')?.querySelector('h3')?.textContent || img.closest('figure')?.querySelector('h3')?.textContent || img.closest('section')?.querySelector('h2')?.textContent || nav?.querySelector('strong')?.textContent || 'Product detail');
      const show = index => {
        setZoom(false);
        current = (index + images.length) % images.length;
        large.src = images[current].src; large.alt = images[current].alt;
        counter.textContent = `${current + 1} / ${images.length}`;
        caption.textContent = captions[current].replace(/\s+/g, ' ').trim();
      };
      const restore = () => {
        if (locked) { document.body.style.overflow = previousOverflow; locked = false; }
        if (origin?.isConnected) origin.focus({preventScroll:true});
      };
      images.forEach((img, index) => {
        const trigger = button(`Enlarge image: ${captions[index].replace(/\s+/g, ' ').trim()}`, 'ag-image-trigger', '');
        const hint = document.createElement('span'); hint.className = 'ag-image-hint'; hint.setAttribute('aria-hidden', 'true');
        hint.append(lineIcon('M14 4h6v6 M20 4l-7 7 M10 20H4v-6 M4 20l7-7'));
        img.before(trigger); trigger.append(img, hint);
        listen(trigger, 'click', () => {
          origin = trigger; show(index); previousOverflow = document.body.style.overflow; locked = true;
          document.body.style.overflow = 'hidden'; dialog.showModal(); close.focus();
        });
        undo.push(() => { trigger.replaceWith(img); });
      });
      listen(zoom, 'click', () => setZoom(!zoomed));
      listen(window, 'resize', () => { if (dialog.open && zoomed) setZoom(true); });
      listen(close, 'click', () => dialog.close());
      listen(dialog, 'close', restore);
      listen(previous, 'click', () => show(current - 1));
      listen(next, 'click', () => show(current + 1));
      listen(dialog, 'keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
      });
      listen(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      let start;
      listen(stage, 'pointerdown', event => {
        if (zoomed || (event.pointerType === 'mouse' && event.button !== 0)) return;
        start = {x:event.clientX, y:event.clientY}; stage.setPointerCapture(event.pointerId);
      });
      listen(stage, 'pointerup', event => {
        if (!zoomed && start && Math.abs(event.clientX-start.x) > 55 && Math.abs(event.clientY-start.y) < 65) show(current + (event.clientX < start.x ? 1 : -1));
        start = undefined;
      });
      listen(stage, 'pointercancel', () => { start = undefined; });
      undo.push(() => { if (dialog.open) dialog.close(); restore(); dialog.remove(); });
    }

    // The storefront already supplies a return-to-top control.
    if (!document.querySelector('.yg-to-top, #ag-global-services')) {
      const top = button('Back to product overview', 'ag-back-top', '↑');
      story.append(top);
      listen(top, 'click', () => {
        story.scrollIntoView({behavior:reducedMotion() ? 'auto' : 'smooth', block:'start'});
        nav?.querySelector('a')?.focus({preventScroll:true});
      });
      let topFrame = 0;
      const updateTop = () => {
        if (!topFrame) topFrame = requestAnimationFrame(() => {
          topFrame = 0; const rect = story.getBoundingClientRect(); top.hidden = rect.top > -600 || rect.bottom < 160;
        });
      };
      top.hidden = true; listen(window, 'scroll', updateTop, {passive:true}); updateTop();
      undo.push(() => { cancelAnimationFrame(topFrame); top.remove(); });
    }

    // Preserve and reversibly fold the native commerce content, when present.
    const info = (document.querySelector('main') || document).querySelector('.product-info');
    if (story.dataset.compactMain === 'true' && info && !info.classList.contains('ag-commerce')) {
      const description = info.querySelector('.product-info__description');
      const delivery = info.querySelector('.yg-product-info__buy-buttons .yg-accordions');
      info.classList.add('ag-commerce'); undo.push(() => info.classList.remove('ag-commerce'));
      function fold(element, label) {
        if (!element || element.closest('.ag-commerce-fold')) return;
        const marker = document.createComment('ag-story-original-position'); element.before(marker);
        const details = document.createElement('details'); details.className = 'ag-commerce-fold';
        const summary = document.createElement('summary'); summary.textContent = label;
        marker.after(details); details.append(summary, element);
        undo.push(() => { if (marker.parentNode) marker.replaceWith(element); details.remove(); });
      }
      if (description && story.dataset.summary && !description.querySelector('.ag-product-intro')) {
        const intro = document.createElement('p'); intro.className = 'ag-commerce-intro'; intro.textContent = story.dataset.summary;
        description.before(intro); undo.push(() => intro.remove()); fold(description, 'Product overview');
      }
      fold(delivery, 'Shipping, delivery & customs');
    }
    return () => undo.reverse().forEach(fn => fn());
  }
  function refresh() {
    instances.forEach(cleanup => cleanup()); instances.clear();
    document.querySelectorAll('.ag-story').forEach(story => instances.set(story, enhance(story)));
  }
  window.agProductStory = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true}); else refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, story) => { if (event.target === story || event.target.contains(story)) { cleanup(); instances.delete(story); } });
  });
})();
